import * as React from 'react'

export function DateCell({ row }) {
  const chat = row.original

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <div className="flex flex-col">{chat.started_at_formatted}</div>
      </div>
    </div>
  )
}
